// extracted by mini-css-extract-plugin
export default {"clearButton":"clear-button_clearButton__m6EzY"};